import React, { Component, ReactNode } from 'react';
import { LoadingSpinnerWrapper } from './LoadingSpinnerStyle';
import { Platform } from 'sofa-reborn-react';
import Loading, { LoadingBall } from '@ingka/loading';

type Props = {
	platform: Platform;
	color?: string;
	isScreenshot: boolean;
};
/**
 * React component.
 *
 */
export default class LoadingSpinner extends Component<Props> {
	/**
	 * React render method.
	 *
	 * @returns React node.
	 */
	public render(): ReactNode {
		const { props } = this;
		return (
			<LoadingSpinnerWrapper color={props.color as string} isScreenshot={props.isScreenshot}>
				<Loading text={''}>
					<LoadingBall color={'emphasised'} size={'large'} />
				</Loading>
			</LoadingSpinnerWrapper>
		);
	}
}
